import React, { useEffect, useReducer, useState } from 'react'
import { Modal } from 'react-bootstrap';
import CalendaRangeInput from '../../../../General/CalendarRangeInput';
import { CSVLink } from 'react-csv';
import FormValidator from '../../../../../utils/FormValidator';
import { enumUtil } from '../../../../../utils/Enum';
import Loader from '../../../../shared/Loader/Loader';
import { ServerRequestProtected } from '../../../../../utils/ServerDataRequest';
import { useSelector } from 'react-redux';
import NotificationHandler from '../../../../../utils/NotificationHandler';
import AmountFormatter from '../../../../../utils/AmountFormatter';
import MultipleCheckboxSelector from '../../../../shared/MultipleCheckboxSelector';
import { ClaimStatus } from '../../../../../utils/Constants';
import isNull from '../../../../../utils/NullChecking';
import GridColumnHeader from '../../../../Setup/Shared/GridColumnHeader';

const AuthorizedUpdatePopup = (props) => {
  let PateintIDR = useSelector(state => state.Open_Patient_Tab.find((pt) => pt.active === true));
  PateintIDR = PateintIDR.data.id
  const API_URL_Search = enumUtil.controller.General;
  const API_UR_ClaimOptions = enumUtil.controller.ClaimOptions;
  const { isOpenAuthorized, onClose, PrevAuthorization, UpdateAuthorization, AuthorizationID, AdditionalCPT } = { ...props }
  // SearchParam
  const SEARCHCRITERIA = {
    "PatientID": PateintIDR + "",
    "PatientAuthorizationID": AuthorizationID + "",
    "DOSFrom": "",
    "DOSTo": "",
    "EntryDateFrom": "",
    "EntryDateTo": "",
    "BillingStatus": ""

  }
  let valModal = {}
  let ValidationModal = {
    NotesVal: '',
  }
  const [searchParam, setSearchParam] = useState(SEARCHCRITERIA)
  const [authroizedData, setauthroizedData] = useState([]);
  const [isUpdate, setisUpdate] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [filter, setClearFilter] = useState(false);
  const [defaultSelectedData, setDefaultSelectedData] = useState([])
  const [TotalClaims, setTotalClaims] = useState(0)
  const [TotalServiceLines, setTotalServiceLines] = useState(0)

  const handleudpate = () => {
    setisUpdate(true);
  }
  const [gridHeader, handleGridHeader] = useReducer((prev, next) => {
    return { ...prev, ...next }
  }, { defaultData: '', activeSortIcon: '' })
  const [validation, setValidation] = useState({ ValidationModal });
  const [Notes, setNotes] = useState('')
  const VisitOptionValidation = async () => {
    let ValidationModal = {
      NotesVal: FormValidator(
        Notes,
        enumUtil.enumValidationType.Required,
        'Notes ',
      )
    }
    await setValidation(ValidationModal)
    valModal = ValidationModal

  }
  const clearFilter = () => {
    setSearchParam(SEARCHCRITERIA);
    setClearFilter(true);
  }
  const LoadDataAuthorizationID = (searchParam) => {

    setIsLoading(true);
   
    ServerRequestProtected(API_URL_Search + "/GetPatientClaims", 'post', {
      "TableName": enumUtil.enumAPITableName.PatientAuthorization,
      SEARCHCRITERIA: searchParam
    })
      .then((response) => {
        setIsLoading(false);
        setauthroizedData(response);
        handleGridHeader({ defaultData: response })
        handleTotalAmount(response)
      }).catch((error) => {
        setIsLoading(false);
        setauthroizedData([]);
        setTotalClaims(0);
        setTotalServiceLines(0)
      })
  }
  useEffect(() => {
    if (isOpenAuthorized) {
      LoadDataAuthorizationID(searchParam);
    }
  }, [isOpenAuthorized]);
  const handleDelete = (index) => {
    const updatedList = [...authroizedData.slice(0, index), ...authroizedData.slice(index + 1)];
    setauthroizedData(updatedList)
  }
  const handleSaveUpdateAuthorization = async () => {
    await VisitOptionValidation()
    clearFilter()
    let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
    if (validation) {
      NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
      return
    }
    else {
      setIsLoading(true);
      let data = {
        Note: Notes
    }
      const updateddata = authroizedData.map((item) => ({
        ClaimID: item.ClaimID + "",
        AuthorizationID: AuthorizationID + "",
        PriorAuthNumber: UpdateAuthorization + "",
        AdditionalCPTCodeID: AdditionalCPT + ""
      }));
      let saveModal = {
        TableName: enumUtil.enumAPITableName.UpdateClaim,
        Value: "AUTHORIZATION",
        Data: data,
        ListofData: updateddata,
      };
      console.log("saveModal:", saveModal);
      ServerRequestProtected(API_UR_ClaimOptions + "/UpdateClaim", 'post', saveModal)
        .then((response) => {
          setIsLoading(false);
          NotificationHandler('Record Saved Successfully! ', enumUtil.enumtoaster.success);
          setNotes('');
          LoadDataAuthorizationID(searchParam)
          setisUpdate(true);
        }).catch((error) => {
          setIsLoading(false);
          setNotes('');
          NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
        });
    }
  };
  const handleClose = () => {
    if (isUpdate) {
      onClose()
    }
    onClose()
  }
  const GetSelectedItems = (items) => {
    let arr = [];
    items.map((key, index) => {
      arr.push(key.value)
    })
    setSearchParam({ ...searchParam, BillingStatus: arr.toString() })
  }
  const SearchByParam = () => {
    if (!isNull(searchParam)) {
      LoadDataAuthorizationID(searchParam)
    } else {
      LoadDataAuthorizationID();
    }
  }
  const handleTotalAmount = (data) => {
    let counter = 0
    let claimid
    let totalWriteOff = 0
    data.map((item) => {
      if (item.ClaimID !== claimid) {
        counter = counter + 1
      }
      claimid = item.ClaimID
    })
    setTotalServiceLines(data.length)
    setTotalClaims(counter)
  }
  return (
    <div>
      <Modal show={isOpenAuthorized} centered dialogClassName=" hk-modal-v1 za-subscriber-id ">
        <Modal.Body>
          {isLoading ? <Loader /> : null}
          <div className='d-flex justify-content-between align-items-center mb-12 px-10'>
            <p></p>
            <p className='heading fs-14'>Update Authorization #</p>
            <i className='icon-Icon-metro-cross' onClick={handleClose} ></i>
          </div>
          <div className='row px-10 mx-0 mb-12 align-items-end px-10'>
            <div className='col-md-4 ps-0'>
              <CalendaRangeInput searchParam={searchParam} setSearchParam={setSearchParam} options={['DOS', 'Entry Date']} />
            </div>
            <div className='col-md-5 row m-0 align-items-end ps-0'>
              <div className='col-md-6 ps-0'>
                <div className="input mb-0">
                  <label htmlFor="" className='heading fs-12'>Status</label>
                  < MultipleCheckboxSelector
                    ItemLists={ClaimStatus}
                    placeHolder="Select Status"
                    GetSelectedItems={GetSelectedItems}
                    clearFilter={filter}
                    setClearFilter={setClearFilter}
                    defaultSelectedData={defaultSelectedData}
                  />
                </div>
              </div>
              <div className='col-md-6 px-0'>
                <div className='btns-group-flex claims_btns'>
                  <button className='btn btn-orange btn-xs no-width rounded'
                    onClick={SearchByParam}>Search</button>
                  <div className='line-border'></div>
                  <button className='btn btn-outline btn-xs no-width rounded' onClick={clearFilter}>Clear</button>
                </div>
              </div>
            </div>
            <div className='col-md-3 text-end'>
              <p className='text font-m drk-green-clr fst-italic fs-10'>Prev ID : {PrevAuthorization}</p>
              <p className='text font-m drk-green-clr fst-italic fs-10'>New ID : {UpdateAuthorization}</p>
            </div>
          </div>
          <div className='ar-writeoff-screen'>
            <div className='ar-row'>
              <p className='heading'>Authorization </p>
              <div className='d-flex align-items-center'>
                <p className='text ar-light-color fs-11 fw-500 pe-2'>Total Claims : <span className='fw-600'>{authroizedData.length}</span></p>
                {/* <p className='text ar-light-color fs-11 fw-500 ps-1'>Total ServceLines :  <span className='fw-600'>{TotalServiceLines}</span></p> */}
              </div>
            </div>
          </div>

          <div className='card-body hk-expand-table ad-expand-table service_line mb-2 mx-10 za_table auth-table'>
            <table className=''>
              <thead>
                <tr>
                  <th>
                    <GridColumnHeader iconName="icon-name" headerName="Patient" sortIcon={true} data={authroizedData} setData={setauthroizedData} 
                    type="string" 
                    colKey="Patient"
                    gridHeader={gridHeader}
                    handleGridHeader={handleGridHeader}
                  />
                  </th>
                  <th>
                    <GridColumnHeader iconName="icon-name" headerName="Account#" sortIcon={true} data={authroizedData} setData={setauthroizedData} 
                    type="string" 
                    colKey="AccountNumber"
                    gridHeader={gridHeader}
                    handleGridHeader={handleGridHeader}
                  />
                  </th>
                  <th className='heading fs-12'>Current Authorization ID</th>
                  <th className='heading fs-12 text-center'>Authorization #</th>
                  <th className='heading fs-12'>
                    <GridColumnHeader iconName="icon-name" headerName="Claim ID" sortIcon={true} data={authroizedData} setData={setauthroizedData} 
                    type="number" 
                    colKey="ClaimID"
                    gridHeader={gridHeader}
                    handleGridHeader={handleGridHeader}
                  />
                  </th>
                  <th>
                    <GridColumnHeader iconName="icon-name" headerName="DOS" sortIcon={true} data={authroizedData} setData={setauthroizedData} 
                    type="date" 
                    colKey="DOS"
                    gridHeader={gridHeader}
                    handleGridHeader={handleGridHeader}
                  />
                  </th>
                  <th className='heading fs-12'>
                    <GridColumnHeader iconName="icon-name" headerName="Billed" sortIcon={true} data={authroizedData} setData={setauthroizedData} 
                    type="number" 
                    colKey="PrimaryBilledAmount"
                    gridHeader={gridHeader}
                    handleGridHeader={handleGridHeader}
                  />
                  </th>
                  <th className='heading fs-12'>
                    <GridColumnHeader iconName="icon-name" headerName="Paid" sortIcon={true} data={authroizedData} setData={setauthroizedData} 
                    type="number" 
                    colKey="PrimaryPaid"
                    gridHeader={gridHeader}
                    handleGridHeader={handleGridHeader}
                  />
                  </th>
                  <th className='heading fs-12'>
                    <GridColumnHeader iconName="icon-name" headerName="Ins Bal" sortIcon={true} data={authroizedData} setData={setauthroizedData} 
                    type="number" 
                    colKey="PrimaryBalance"
                    gridHeader={gridHeader}
                    handleGridHeader={handleGridHeader}
                  />
                  </th>
                  <th className='heading fs-12'>
                    <GridColumnHeader iconName="icon-name" headerName="Status" sortIcon={true} data={authroizedData} setData={setauthroizedData} 
                    type="number" 
                    colKey="BillingStatus"
                    gridHeader={gridHeader}
                    handleGridHeader={handleGridHeader}
                  />
                  </th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {authroizedData && authroizedData.map((item, index) => {
                  return (
                    <tr>
                      <td className='text fs-12 text-nowrap'>{item.Patient}</td>
                      <td className='text border'>{item.AccountNumber}</td>
                      <td className='text'>{PrevAuthorization}</td>
                      <td> 
                        {isUpdate ? (
                         <div className="hk-table-flex">
                         <input
                           type="text"
                           className="form-control w-100"
                           name="UpdateAuthorization"
                           id="UpdateAuthorization"
                           variant="outlined"
                           value={item.PriorAuthNumber}
                           readOnly
                         />
                       </div>
                      ) : (
                        <div className="hk-table-flex">
                        <input
                          type="text"
                          className="form-control w-100"
                          name="UpdateAuthorization"
                          id="UpdateAuthorization"
                          variant="outlined"
                          value={UpdateAuthorization}
                          readOnly
                        />
                      </div>
                      )}
                      </td>
                      <td className='text'>{item.ClaimID}</td>
                      <td className='heading fs-12'>{item.DOS}</td>
                      <td className='text'><AmountFormatter amount={item.PrimaryBilledAmount} /></td>
                      <td className='text'><AmountFormatter amount={item.PrimaryPaid} /></td>
                      <td className='text'><AmountFormatter amount={item.PrimaryBalance} /></td>
                      <td className='text'>{item.BillingStatus}</td>
                      <td className='text'>
                        <i className='bi bi-trash-fill' onClick={() => handleDelete(index)}> </i>
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>

          <div className={validation.NotesVal ? 'input error pb-2 mx-2' : 'input pb-2 mx-2'}>
            <label className='mb-1' >Notes</label>
            <textarea
              className="form-control doc-textarea"
              placeholder="Add Notes" value={Notes} onChange={(e) => setNotes(e.target.value)}
              rows={2}
            >
            </textarea>
            {validation.NotesVal}
          </div>
          <div className='border-top '></div>
          <div className="modal_footer ar-border-color px-10">
            <div className="text-end">
              <div className="btns-group">
                {isUpdate === true ?
                  <div className='d-flex align-items-center justify-content-end'>
                    <CSVLink className='ar-btn-primary border-0 btn' filename={"Authorization.csv"} data={authroizedData}>Export</CSVLink>
                  </div>
                  :
                  <div className="btns-group">
                    <button className="btn btn-gray" onClick={onClose}>Cancel</button>
                    <button className="btn btn-orange" onClick={handleSaveUpdateAuthorization}>Update</button>
                  </div>
                }
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  )
}

export default AuthorizedUpdatePopup